import React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Portal from '@mui/base/Portal';

var vertical='top',horizontal='center';

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const [open, setOpen] = React.useState(false); 
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  function hideAlert(){
		setOpen(false);
	}
  
  return (<Portal>
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={open} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
        <Alert onClose={hideAlert} variant="filled" severity={props.severityAlert} sx={{ width: '100%' }}>
          {props.alertMessage}
        </Alert>
      </Snackbar>
    </Stack>
    </Portal>
  );

});

export default CustomizedDialogs;